import { EntityStateEnum } from "@app/shared/common/enums";

export class QuestionConceptPostItem{
    organizationID: string;
    name: string;
    languageID: string;
    type: string;
    entityState: EntityStateEnum
}